
import TableList from "@components/templates/tablelist";
import { HttpCarrierList, HttpChangeCarrierOne } from "@/service/fedex";
import comRulecopy from './rulecopy'
import { mapGetters } from "vuex";
// import mixin from "../mixin";
export default {
    mixins: [TableList],
    components:{
        comRulecopy
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpCarrierList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'fedexCarrierUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "query":
                    var url = this.$router.resolve({
                        name: "fedexCarrierUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'edit':
                    this.$router.push({
                        name: 'fedexCarrierUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "noInvalid":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params, status:0 },
                        title: "禁用",
                        content:"禁用后无法参与测算，是否确认禁用？",
                        ajaxRequest: HttpChangeCarrierOne
                    };
                    break;
                case "isInvalid":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params, status:1 },
                        title: "启用",
                        ajaxRequest: HttpChangeCarrierOne
                    };
                    break;
                case 'rulecopy':
                    this.operate = {
                        show: true,
                        title: '复制规则',
                        width: 500,
                        showFooter: false,
                        component: "comRulecopy",
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, isInvalid } = row
            return [{
                label: '查看详情',
                show: true,
                params: id,
                operate: 'query'
            },
            {
                label: '编辑',
                show: true,
                params: id,
                operate: 'edit'
            },
            {
                label: '禁用',
                show: isInvalid == 'isInvalid',
                params: id,
                operate: 'noInvalid'
            },
            {
                label: '启用',
                show: isInvalid == 'noInvalid',
                params: id,
                operate: 'isInvalid'
            }
            ]
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getCusproductList','getCarrierServiceList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "规则复制",
                    operate: "rulecopy",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "组织",
                    tag: 'vSelect',
                    key: 'EQ_orgId',
                    show: true,
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "仓库",
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getBillcusWareList.map(item=>{
                        return {
                            value: item.attach.code,
                            label: item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "状态",
                    tag: 'vSelect',
                    key: 'EQ_isInvalid',
                    show: true,
                    options: [
                        {value:'isInvalid', label:'启用'},
                        {value:'noInvalid', label:'禁用'},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "是否自动测算",
                    tag: 'vSelect',
                    key: 'EQ_isCalculation',
                    options: [
                        {value:'isCalculation', label:'是'},
                        {value:'noCalculation', label:'否'}
                    ],
                    props: {
                        filterable: true,
                    }
                },

                {
                    label: "是否oversize",
                    tag: 'vSelect',
                    key: 'EQ_isOversize',
                    options: [
                        {label: '是', value: 'isOversize'},
                        {label: '否', value: 'noOversize'},
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "原carrier",
                    tag: 'vSelect',
                    key: 'EQ_carrierCode',
                    options: this.getCarrierServiceList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "目标结算carrier",
                    tag: 'vSelect',
                    key: 'EQ_targetCarrierCode',
                    options: this.getCarrierServiceList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: '组织',
                    render: (h, { row }) => this.findRenderLabel(this.getBillcusorgList, row.orgId)
                },
                {
                    title: '仓库',
                    render:(h,{row})=>{
                        let orgWarehouseCode = row.orgWarehouseCode
                        let orgWarehouse = this.getBillcusWareList.find(item=>{
                            return item.attach.code == orgWarehouseCode
                        })
                        return <div>
                            {orgWarehouse ? orgWarehouse.label : '--'}
                        </div>
                    }
                    // render: (h, { row }) => this.findRenderLabel(this.getBillcusWareList, row.orgWarehouseCode)
                },
                {
                    title: '状态',
                    render: (h, { row }) => {
                        switch (row.isInvalid) {
                            case "isInvalid": return <div>启用</div>; break;
                            case "noInvalid": return <div>禁用</div>; break;
                        }
                    }
                },
                {
                    title: '是否自动测算',
                    render: (h, { row }) => {
                        switch (row.isOversize) {
                            case "isCalculation": return <div>是</div>; break;
                            case "noCalculation": return <div>否</div>; break;
                        }
                    }
                },
                {
                    title: '是否Oversize',
                    render: (h, { row }) => {
                        switch (row.isOversize) {
                            case "isOversize": return <div>是</div>; break;
                            case "noOversize": return <div>否</div>; break;
                        }
                    }
                },
                {
                    title: '原Carrier',
                    render: (h, { row }) => this.findRenderLabel(this.getCarrierServiceList, row.carrierCode)
                },
                {
                    title: '目标结算Carrier',
                    render: (h, { row }) => this.findRenderLabel(this.getCarrierServiceList, row.targetCarrierCode)
                },
                {
                    title: '创建人',
                    key: 'createdName',
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                },
            ];
        },

    },

};
